import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import LogoutUser from "../../../../common/snippet/logOut";
// import {GetClientUserPermByIdForClient} from '../../../../actions/client-portal/AllUsersApi';
const WorkerPortalSideNav = () => {
  const dispatch = useDispatch();
  const permissionData = JSON.parse(localStorage.getItem("permission_data"));
  let permission_data;
  // let function_assignment_id
  // let user_id;
  if (permissionData !== null) {
    permission_data = permissionData;
  }
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  if (storedData !== null) {
    // user_id =  storedData?.userName?.user_id;
    // function_assignment_id = storedData.function_assignment_id;
  }
  // useEffect(() =>{
  //   const apiData = {
  //     user_id: user_id,
  //     function_assignment_id: function_assignment_id
  //   }
  //   dispatch(GetClientUserPermByIdForClient(apiData)).then(
  //     (response) => {
  //        if (response.success === true) {
  //           // const arrayData = response.data;
  //           localStorage.setItem("permission_data", JSON.stringify(response.data))
  //         }
  //        }
  //   );
  // },[])

  return (
    <React.Fragment>
      <div className="sideNav">
        <div className="logo-wrap">
          <span>
            <img src="/assets/icons-svg/navIcons/logo.svg" alt="" />
          </span>
        </div>
        <ul>
          <li>
            <NavLink to="dashboard">
              <span className="icons-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span className="text-wrap">Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="documents">
              <span className="icons-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="20"
                  viewBox="0 0 23 20"
                  fill="none"
                >
                  <path
                    d="M19.583 6V14.2C19.583 15.8802 19.583 16.7202 19.256 17.362C18.9684 17.9265 18.5095 18.3854 17.945 18.673C17.3032 19 16.4632 19 14.783 19H7.38301C5.70285 19 4.86277 19 4.22104 18.673C3.65655 18.3854 3.19761 17.9265 2.90999 17.362C2.58301 16.7202 2.58301 15.8802 2.58301 14.2V6M2.68301 1H19.483C20.0431 1 20.3231 1 20.537 1.10899C20.7252 1.20487 20.8781 1.35785 20.974 1.54601C21.083 1.75992 21.083 2.03995 21.083 2.6V4.4C21.083 4.96005 21.083 5.24008 20.974 5.45399C20.8781 5.64215 20.7252 5.79513 20.537 5.89101C20.3231 6 20.0431 6 19.483 6H2.68301C2.12296 6 1.84293 6 1.62902 5.89101C1.44086 5.79513 1.28787 5.64215 1.192 5.45399C1.08301 5.24008 1.08301 4.96005 1.08301 4.4V2.6C1.08301 2.03995 1.08301 1.75992 1.192 1.54601C1.28787 1.35785 1.44086 1.20487 1.62902 1.10899C1.84293 1 2.12296 1 2.68301 1ZM8.68301 9.5H13.483C14.0431 9.5 14.3231 9.5 14.537 9.60899C14.7252 9.70487 14.8781 9.85785 14.974 10.046C15.083 10.2599 15.083 10.5399 15.083 11.1V11.9C15.083 12.4601 15.083 12.7401 14.974 12.954C14.8781 13.1422 14.7252 13.2951 14.537 13.391C14.3231 13.5 14.0431 13.5 13.483 13.5H8.68301C8.12296 13.5 7.84293 13.5 7.62902 13.391C7.44086 13.2951 7.28787 13.1422 7.192 12.954C7.08301 12.7401 7.08301 12.4601 7.08301 11.9V11.1C7.08301 10.5399 7.08301 10.2599 7.192 10.046C7.28787 9.85785 7.44086 9.70487 7.62902 9.60899C7.84293 9.5 8.12296 9.5 8.68301 9.5Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span className="text-wrap">My Documents</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="inductions">
              <span className="icons-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span className="text-wrap">Inductions</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="siteLog">
              <span className="icons-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.12602 13.9997C8.57006 15.725 10.1362 16.9997 12 16.9997C13.8638 16.9997 15.4299 15.725 15.874 13.9997M11.0177 2.76375L4.23539 8.03888C3.78202 8.3915 3.55534 8.56781 3.39203 8.78861C3.24737 8.9842 3.1396 9.20454 3.07403 9.43881C3 9.70327 3 9.99045 3 10.5648V17.7997C3 18.9198 3 19.4799 3.21799 19.9077C3.40973 20.284 3.71569 20.59 4.09202 20.7818C4.51984 20.9997 5.07989 20.9997 6.2 20.9997H17.8C18.9201 20.9997 19.4802 20.9997 19.908 20.7818C20.2843 20.59 20.5903 20.284 20.782 19.9077C21 19.4799 21 18.9198 21 17.7997V10.5648C21 9.99045 21 9.70327 20.926 9.43881C20.8604 9.20454 20.7526 8.9842 20.608 8.78861C20.4447 8.56781 20.218 8.3915 19.7646 8.03888L12.9823 2.76376C12.631 2.4905 12.4553 2.35388 12.2613 2.30136C12.0902 2.25502 11.9098 2.25502 11.7387 2.30136C11.5447 2.35388 11.369 2.4905 11.0177 2.76375Z"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span className="text-wrap">Site Log</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="contractors">
              <span className="icons-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.1658 20.8745C19.9709 20.8745 20.6214 20.2225 20.6214 19.4191V15.5467C20.6214 14.7434 19.9709 14.0914 19.1658 14.0914H13.3557C12.5506 14.0914 11.9 14.7434 11.9 15.5467V19.4191C11.9 20.2225 12.5506 20.8745 13.3557 20.8745H19.1658ZM19.1658 19.5128H13.3557C13.304 19.5128 13.262 19.4707 13.262 19.4191V15.5467C13.262 15.4951 13.304 15.4531 13.3557 15.4531H19.1658C19.2174 15.4531 19.2594 15.4951 19.2594 15.5467V19.4191C19.2594 19.4707 19.2174 19.5128 19.1658 19.5128Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M19.2593 15.5458C19.2593 16.0251 18.8703 16.4141 18.391 16.4141H14.1303C13.651 16.4141 13.262 16.0251 13.262 15.5458C13.262 15.1699 12.9569 14.8648 12.581 14.8648C12.2051 14.8648 11.9 15.1699 11.9 15.5458C11.9 16.7769 12.8992 17.7761 14.1303 17.7761H18.391C19.6221 17.7761 20.6213 16.7769 20.6213 15.5458C20.6213 15.1699 20.3162 14.8648 19.9403 14.8648C19.5644 14.8648 19.2593 15.1699 19.2593 15.5458Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.81 14.889C18.1307 14.889 18.391 14.6287 18.391 14.308V13.5333C18.391 12.785 17.7852 12.1777 17.0354 12.1777H15.486C14.7362 12.1777 14.1304 12.785 14.1304 13.5333V14.308C14.1304 14.6287 14.3907 14.889 14.7114 14.889H17.81ZM17.229 13.8727H15.2924V13.5333C15.2924 13.4265 15.3792 13.3397 15.486 13.3397H17.0354C17.1422 13.3397 17.229 13.4265 17.229 13.5333V13.8727Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M10.78 14.0664C8.90316 14.098 5.33487 14.7346 3.56036 18.5573C3.34841 19.0142 3.38479 19.737 4.73027 19.776C6.07575 19.815 8.606 19.7923 10.166 19.776"
                    stroke="#5786CC"
                    stroke-width="1.95"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="11.5698"
                    cy="7.90674"
                    r="3.75986"
                    stroke="#5786CC"
                    stroke-width="1.95"
                  />
                </svg>
              </span>
              <span className="text-wrap">Providers</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="clientsAssigned">
              <span className="icons-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M20.9005 6.84647L20.9005 6.84648C21.2976 6.91279 21.5888 7.2563 21.5888 7.65874V20.6823C21.5888 21.1371 21.2203 21.5058 20.7653 21.5058H14.9771C14.5224 21.5058 14.1536 21.1367 14.1536 20.6823C14.1536 20.2278 14.5224 19.8587 14.9771 19.8587H19.942L19.9419 8.35648L12.9064 7.18397V20.6823C12.9064 21.1367 12.5377 21.5058 12.0829 21.5058C11.6283 21.5058 11.2596 21.1367 11.2596 20.6823V6.21176C11.2596 5.96961 11.366 5.73994 11.5507 5.58353C11.7353 5.42699 11.9797 5.3597 12.2182 5.39948C12.2182 5.39948 12.2182 5.39948 12.2183 5.39948L20.9005 6.84647Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M14.1538 17.0633C14.1538 16.6083 14.5223 16.2398 14.9773 16.2398H17.8714C18.3265 16.2398 18.695 16.6083 18.695 17.0633V20.6809C18.695 21.1358 18.3265 21.5045 17.8714 21.5045H14.9773C14.5223 21.5045 14.1538 21.1358 14.1538 20.6809V17.0633ZM15.8009 19.8574H17.048V17.8868H15.8009V19.8574Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M5.47147 17.0633C5.47147 16.6083 5.8401 16.2398 6.29503 16.2398H9.18916C9.64411 16.2398 10.0126 16.6083 10.0126 17.0633V20.6809C10.0126 21.1358 9.64414 21.5045 9.18916 21.5045H6.29503C5.84008 21.5045 5.47147 21.1359 5.47147 20.6809V17.0633ZM7.11862 19.8574H8.36561V17.8868H7.11862V19.8574Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M3.53638 2.50484L3.53648 2.50486L12.2187 3.9521C12.6158 4.01828 12.9069 4.36169 12.9069 4.76436V20.6819C12.9069 21.1367 12.5385 21.5053 12.0835 21.5053H6.29518C5.84055 21.5053 5.47187 21.1362 5.47187 20.6819C5.47187 20.2276 5.84055 19.8584 6.29518 19.8584H11.2601L11.2602 5.4621L4.22461 4.28935V20.6819C4.22461 21.1362 3.85593 21.5054 3.4013 21.5054C2.94656 21.5054 2.57787 21.1362 2.57787 20.6819V3.31713C2.57787 3.075 2.68443 2.84561 2.86894 2.68915C3.05363 2.5323 3.298 2.46536 3.53638 2.50484Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M17.0479 13.0845C17.0479 12.8295 17.2547 12.6227 17.5096 12.6227H18.2332C18.4881 12.6227 18.695 12.8295 18.695 13.0845V13.808C18.695 14.0628 18.4882 14.2698 18.2332 14.2698H17.5096C17.2547 14.2698 17.0479 14.0628 17.0479 13.808V13.0845Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M14.1539 13.0845C14.1539 12.8295 14.3607 12.6227 14.6157 12.6227H15.3391C15.5941 12.6227 15.8009 12.8295 15.8009 13.0845V13.808C15.8009 14.0628 15.5941 14.2698 15.3391 14.2698H14.6157C14.3607 14.2698 14.1539 14.0628 14.1539 13.808V13.0845Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M14.1539 10.1899C14.1539 9.9351 14.3607 9.72812 14.6157 9.72812H15.3391C15.5941 9.72812 15.8009 9.93508 15.8009 10.1899V10.9135C15.8009 11.1683 15.5941 11.3753 15.3391 11.3753H14.6157C14.3607 11.3753 14.1539 11.1683 14.1539 10.9135V10.1899Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M17.0479 10.1899C17.0479 9.93512 17.2547 9.72812 17.5096 9.72812H18.2332C18.4882 9.72812 18.695 9.93508 18.695 10.1899V10.9135C18.695 11.1683 18.4882 11.3753 18.2332 11.3753H17.5096C17.2547 11.3753 17.0479 11.1683 17.0479 10.9135V10.1899Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M8.36558 13.0845C8.36558 12.8295 8.57239 12.6227 8.82737 12.6227H9.55093C9.8058 12.6227 10.0126 12.8295 10.0126 13.0845V13.808C10.0126 14.0628 9.80583 14.2698 9.55093 14.2698H8.82737C8.57238 14.2698 8.36558 14.0628 8.36558 13.808V13.0845Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M5.47117 13.0845C5.47117 12.8295 5.67798 12.6227 5.93296 12.6227H6.65652C6.91134 12.6227 7.11831 12.8294 7.11831 13.0845V13.808C7.11831 14.0629 6.91138 14.2698 6.65652 14.2698H5.93296C5.67797 14.2698 5.47117 14.0628 5.47117 13.808V13.0845Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M5.47117 10.1899C5.47117 9.9351 5.67796 9.72812 5.93296 9.72812H6.65652C6.91136 9.72812 7.11831 9.93506 7.11831 10.1899V10.9135C7.11831 11.1683 6.91138 11.3753 6.65652 11.3753H5.93296C5.67797 11.3753 5.47117 11.1683 5.47117 10.9135V10.1899Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M8.36558 10.1899C8.36558 9.9351 8.57237 9.72812 8.82737 9.72812H9.55093C9.80582 9.72812 10.0126 9.9351 10.0126 10.1899V10.9135C10.0126 11.1683 9.80583 11.3753 9.55093 11.3753H8.82737C8.57238 11.3753 8.36558 11.1683 8.36558 10.9135V10.1899Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M8.36558 7.29734C8.36558 7.04252 8.57237 6.83555 8.82737 6.83555H9.55093C9.80582 6.83555 10.0126 7.04252 10.0126 7.29734V8.0209C10.0126 8.27584 9.80581 8.48269 9.55093 8.48269H8.82737C8.57241 8.48269 8.36558 8.27588 8.36558 8.0209V7.29734Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                  <path
                    d="M5.47117 7.29734C5.47117 7.04252 5.67796 6.83555 5.93296 6.83555H6.65652C6.91136 6.83555 7.11831 7.04248 7.11831 7.29734V8.0209C7.11831 8.27588 6.91136 8.48269 6.65652 8.48269H5.93296C5.67799 8.48269 5.47117 8.27588 5.47117 8.0209V7.29734Z"
                    fill="#5786CC"
                    stroke="#5786CC"
                    stroke-width="0.2"
                  />
                </svg>
              </span>
              <span className="text-wrap">Clients Assigned</span>
            </NavLink>
          </li>
        </ul>
        <div className="mt-auto">
          <ul>
            <li>
              <NavLink to="support">
                <span className="icons-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M21 18V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12V18M5.5 21C4.11929 21 3 19.8807 3 18.5V16.5C3 15.1193 4.11929 14 5.5 14C6.88071 14 8 15.1193 8 16.5V18.5C8 19.8807 6.88071 21 5.5 21ZM18.5 21C17.1193 21 16 19.8807 16 18.5V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V18.5C21 19.8807 19.8807 21 18.5 21Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-wrap">Support</span>
              </NavLink>
            </li>
            {/* {permission_data.settings_view && ( */}
            <li>
              <NavLink to="settings">
                <span className="icons-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-wrap">Settings</span>
              </NavLink>
            </li>
            {/* )} */}
            <li>
              <hr />
            </li>
            <li>
              <LogoutUser logOut={"client"} SetAlign={true} />
            </li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};
export default WorkerPortalSideNav;
